<template>
  <div id="contenedor-eliminar-funcionario">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Responsable </v-card-title>
      <v-card-text>
        <span class="secondary--text">
          ¿Desea eliminar al responsable "{{funcionarioEliminar.nombre}}"?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarFuncionario"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixCatalogoFuncionarios from './mixCatalogoFuncionarios';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'CatalogosFuncionariosEditar',
  mixins: [mixCatalogoFuncionarios],
  props: {
    funcionarioEliminar: {
      type: Object,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      esFormularioValido: false,
      enviandoFormulario: false,
      funcionario: {
        nombre: this.funcionarioEliminar.nombre,
        puesto: this.funcionarioEliminar.puesto,
        fechaNombramiento: this.funcionarioEliminar.fechaNombramiento,
        esSupervisor: this.funcionarioEliminar.esSupervisor,
      },
      date: '',
      menu: false,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">
</style>
